import React from 'react';
import { useTranslation } from 'react-i18next';
import { container } from "assets/jss/material-kit-react.js";
import { makeStyles } from "@material-ui/core/styles";

export default function AnyQuestionsComponent() {

  const useStyles = makeStyles({
    container,
    askiesewrapper: {
      background: "linear-gradient(0deg, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.55)), url(/img/AskQuestionsBackgroundImg.png)",
      backgroundPosition: "center",
      backgroundSize: "cover",
      margin: "0 64px",
      padding: "96px 64px",
      "& a": {
        cursor: "pointer"
      },
      "@media (max-width: 766px)": {
        margin: "0 20px",
        padding: "48px 24px"
      }
    },
    whatsappimg: {
      filter: "invert(53%) sepia(98%) saturate(1073%) hue-rotate(111deg) brightness(93%) contrast(98%)",
      verticalAlign: "sub",
      paddingRight: "8px",
    }
  });

  const classes = useStyles();
  const { t } = useTranslation();
  const isWebView = function () { 
      if (typeof window === undefined) { return false };
          let navigator = window.navigator;

          const standalone = navigator.standalone;
          const userAgent = navigator.userAgent.toLowerCase();
          const safari = /safari/.test(userAgent);
          const ios = /iphone|ipod|ipad|macintosh/.test(userAgent);
          const ios_ipad_webview = ios && !safari;
      
          return ios ? ( (!standalone && !safari) || ios_ipad_webview ) : userAgent.includes('wv');
      }

  return (
    <div className={classes.askiesewrapper}>
      <div className="semibold-h400 cl-secondary-100 paddingBottom64">{t("AskQuestionsTitle")}</div>
      <div className="flexWrapper">
        <div>
          <div className="semibold-h300 cl-secondary-100 paddingBottom24">
          {t("AskQuestionsEmail")}
          </div>
          <div className="regular-b300 cl-secondary-100 paddingBottom24">
          {t("AskQuestionsEmailDesc")}
          </div>
          <div className="askiese-search-wrapper">
          <a className='cl-secondary-100 semibold-b300 myIeseButton anyquestions' onClick={()=>{window.open('mailto:alumnicommunity@iese.edu', isWebView ? '_self' : '_blank')}}>{t("AskQuestionsEmailButton")}</a>
          </div>
        </div>
        <div>
          <div className="semibold-h300 cl-secondary-100 paddingBottom24 paddingTop40Mobile">
          {t("AskQuestionsWhatsapp")}
          </div>
          <div className="regular-b300 cl-secondary-100 paddingBottom24">
          {t("AskQuestionsWhatsappDesc")}
          </div>
          <a className='cl-secondary-100 semibold-b300 myIeseButton anyquestions' onClick={()=>{window.open('https://alumni.iese.edu/page/qa-y-ayuda', '_blank')}}>{t("AskQuestionsWhatsappButton")}</a>
          {/* <a className='cl-secondary-100 semibold-b300' onClick={()=>{window.open('https://wa.me/34650114045', '_blank')}}><img loading="lazy" className={classes.whatsappimg} alt="Whatsapp" src="/img/whatsapp24.svg" />{t("AskQuestionsWhatsappButton")}</a> */}
          {/* <a className='cl-secondary-100 semibold-b300' onClick={()=>{window.openZendeskWindow()}}>{t("AskQuestionsWhatsappButton")}</a> */}
        </div>
      </div>
    </div>
  );
}